<template>
  <div class="finance-verify m-30 ly-card">
    <h2>
      <i class="el-icon-warning"></i>
      <span class="p-l-10">每日10点前完成前一日数据更新，当前数据更新至2019-09-30</span>
    </h2>
    <div class="flex">
      <span>对账单时间</span>
      <el-date-picker
        v-model="date"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
      ></el-date-picker>
    </div>
    <el-button type="primary" @click.native="downLoad">打包下载</el-button>
  </div>
</template>
<script>
import { DatePicker } from 'element-ui';
import { finance } from '@/api';
import utils from '@/utils/utils';

export default {
  name: 'FinanceIncome',
  components: {
    ElDatePicker: DatePicker
  },
  data() {
    return {
      date: '',
      type: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    downLoad() {
      if (!this.date.length) {
        this.$message.warning('请选择对账时间！');
        return;
      }
      finance
        .verifyBill({
          params: {
            verify_bill_start_time: this.date[0],
            verify_bill_end_time: this.date[1]
          }
        })
        .then(data => {
          if (data) utils.downloadData(data, `财务对账${this.date[0]}至${this.date[1]}`);
        });
    }
  }
};
</script>
<style lang="less">
.finance-verify {
  box-shadow: none;
  h2 {
    color: @danger;
  }
  .flex {
    display: flex;
    align-items: center;
    margin: 20px 0;
    > span {
      width: 100px;
    }
  }
}
</style>
